import React from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import Button from '../../components/Button/Button'
import TabNavLink from '../../components/TabNavLink/TabNavLink'
import DynamicFaIcon from '../../components/DynamicFaIcon/DynamicFaIcon'
import { TabOptionProps } from '../../components/TabNavLink/TabNavLink'

const options: TabOptionProps[] = [
    {
        label: 'In behandeling',
        route: ''
    },
    {
        label: 'Archief',
        route: 'archived',
        icon: 'archive'
    }
]

const Orders: React.FunctionComponent = () => {
    return (
        <div>
            <div className='flex justify-between items-center my-2 flex-wrap gap-4 mb-4'>
                <h2>Mijn opdrachten</h2>
                <Button>
                    <NavLink to={'/dashboard/new-order'}>
                        <DynamicFaIcon iconName='plus' className='mr-2' />
                        Nieuwe opdracht
                    </NavLink>
                </Button>
            </div>
            <div className='flex flex-col shadow-sm space-y-4 bg-white border-full rounded-xl'>
                <TabNavLink options={options} navLinkClasses='sm:last:ml-auto' />
                <Outlet />
            </div>
        </div>
    )
}

export default Orders
